module.exports = __webpack_public_path__ + "img/W-S66.9e86f028.jpg";